export default __webpack_public_path__ + "static/media/edit-pencil-fill.e23578d2.svg";